import './HomeAbout.css'

const HomeAbout = () => {
  return (
    <section className="home-about">
      <div className="home-about-container">
        <div className="home-about-content">
          <h2>Um Okkur</h2>
          
          <div className="about-section">
            <h3>Hver Við Erum</h3>
            <p>
              Vélvirki ehf. er með yfir 30 ára reynslu í stálsmíði og 
              bátaviðgerðum. Við leggjum áherslu á gæði og traust, 
              með persónulega þjónustu sem uppfyllir þarfir 
              viðskiptavina.
            </p>
          </div>

          <div className="about-section">
            <h3>Hvað Við Gerum</h3>
            <p>
              Við sérhæfum okkur í stálsmíði, rennismíði og viðgerðum 
              fyrir sjávarútveg og iðnað. Allt frá smábátaviðhaldi til 
              flóknari verkefna, tryggjum við lausnir sem endast.
            </p>
          </div>

          <div className="about-section">
            <h3>Okkar Markmið</h3>
            <p>
              Markmið okkar er að veita faglega þjónustu, áreiðanleika 
              og gæði í hverju einasta verki, með áherslu á þarfir 
              viðskiptavina.
            </p>
          </div>
        </div>
        
        <div className="home-about-image">
          <img src="/home-about.png" alt="Vélvirki ehf. starfsmaður að vinnu" />
        </div>
      </div>
    </section>
  )
}

export default HomeAbout 